// extracted by mini-css-extract-plugin
export var active = "header-module--active--G-m6A";
export var component = "header-module--component--2bBCU";
export var link = "header-module--link--iZUTJ";
export var logo = "header-module--logo--SDS9L";
export var nav = "header-module--nav--oapGi";
export var svg = "header-module--svg--FQQXh";
export var versionIndex = "header-module--version-index--yszR2";